module.exports = __webpack_public_path__ + "static/media/weixin-sh.3bea1c12.jpg";